import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppSpinnerDivComponent} from './app-spinner-div.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        AppSpinnerDivComponent
    ],
    exports: [
        AppSpinnerDivComponent
    ]
})
export class AppSpinnerDivModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-spinner-div/app-spinner-div.module.ts